import React from 'react';
import '../template-file-css/document-file-template.css';


export const LBS_TreatmentPlanUpdateQuestionnaire = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='LBS_TreatmentPlanUpdateQuestionnaire' className='file-pdf-document'>
            <div className='file-template'>
             <h3>Goal: Case Management</h3>
              <table>
                <tr>
                    <td className='w-750'><span className='eleHeader'>1. Progress?</span>
                      <span className='small'>(Circle One)</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-250'><input type="radio" id="rbProgress_1_1" name="rbProgress_1" className='add-only' value="Minor" /> Minor</td>
                    <td className='w-250'><input type="radio" id="rbProgress_1_2" name="rbProgress_1" className='add-only' value="Moderate" /> Moderate</td>
                    <td className='w-250'><input type="radio" id="rbProgress_1_3" name="rbProgress_1" className='add-only' value="Significant" /> Significant</td>
                </tr>
              </table>
              <p className='w-750'>
                <span className='eleHeader'>2. What resources have been given to the client/family since the last update?</span>
                <textarea id="txtClientFamilyUpdate" name="txtClientFamilyUpdate" className='add-only'></textarea>
              </p>
              <table>
                 <tr>
                    <td className='w-750'><span className='eleHeader'>3. Are they utilizing resources? </span>
                      <span className='small'>(Circle One)</span>
                    </td>
                 </tr>
                 <tr>
                    <td className='w-250'> <input type="radio" id="rbUtilizingResources_yes" name="rbUtilizingResources" className='add-only' value="Yes" /> Yes</td>
                    <td className='w-250'><input type="radio" id="rbUtilizingResources_No" name="rbUtilizingResources" className='add-only' value="No" /> No</td>
                 </tr>
                 <tr>
                    <td className='w-250'>
                        <b>If not,</b>
                    </td>
                 </tr>
                 <tr>
                    <td className='w-750'>
                      <span className='eleHeader'>why?</span> 
                      <input type="text" id="txtIfNotWhy" name="txtIfNotWhy" className='add-only' />
                    </td>
                 </tr>
              </table>
              <h3>Goal: Nurturing Parenting Program/Parenting Skills Training</h3>
              <span className='small'>(IGNORE FOR ADULTS)</span>
              <table>
                <tr>
                    <td className='w-750'><span className='eleHeader'>1. Progress?</span>
                      <span className='small'>(Circle One)</span>
                    </td>
                </tr>
                <tr>
                    <td className='w-250'><input type="radio" id="rbProgress_2_1" name="rbProgress_2" className='add-only' value="Minor" /> Minor</td>
                    <td className='w-250'><input type="radio" id="rbProgress_2_2" name="rbProgress_2" className='add-only' value="Moderate" /> Moderate</td>
                    <td className='w-250'><input type="radio" id="rbProgress_2_3" name="rbProgress_2" className='add-only' value="Significant" /> Significant</td>
                </tr>
              </table>
              <p className='w-750'>
                <span className='eleHeader'>2. What objectives/interventions are working and not working?</span>
                <textarea id="txtWhatObjectivesInterventions" name="txtWhatObjectivesInterventions" className='add-only'></textarea>
              </p>
              <p className='w-750'>
                <span className='eleHeader'>3. Suggestions for addition or deletion of objectives/interventions?</span>
                <textarea id="txtSuggestionsObjectivesInterventions" name="txtWhatObjectivesInterventions" className='add-only'></textarea>
              </p>
              <h3>Goal: Medication Training and Support</h3>
              <table>
                <tr>
                    <td className='w-750'><span className='eleHeader'>1. Progress?</span>
                    <span className='small'>(Circle One)</span></td>
                </tr>
                <tr>
                    <td className='w-187'><input type="radio" id="rbProgress_3_1" name="rbProgress_3" className='add-only' value="Minor" /> Minor</td>
                    <td className='w-187'><input type="radio" id="rbProgress_3_2" name="rbProgress_3" className='add-only' value="Moderate" /> Moderate</td>
                    <td className='w-187'><input type="radio" id="rbProgress_3_3" name="rbProgress_3" className='add-only' value="Significant" /> Significant</td>
                    <td className='w-187'><input type="radio" id="rbProgress_3_4" name="rbProgress_3" className='add-only' value="Not Applicable" /> Not Applicable</td>
                </tr>
              </table>
              <p className='w-750'>
                <span className='eleHeader'>2. Why did you select Minor/Moderate/Significant progress above?</span>
                <textarea id="txtSelectProgress" name="txtSelectProgress" className='add-only'></textarea>
              </p>
              <table>
                 <tr>
                    <td className='w-750'><span className='eleHeader'>3.  Is the client compliant with taking their medication? </span>
                    <span className='small'>(Circle One)</span></td>
                 </tr>
                 <tr>
                    <td className='w-250'> <input type="radio" id="rbTakingMedication_yes" name="rbTakingMedication" className='add-only' value="Yes" /> Yes</td>
                    <td className='w-250'><input type="radio" id="rbTakingMedication_No" name="rbTakingMedication" className='add-only' value="No" /> No</td>
                    <td className='w-250'><input type="radio" id="rbTakingMedication_NA" name="rbTakingMedication" className='add-only' value="Not Applicable" /> Not Applicable</td>
                 </tr>
              </table>
              <table>
                 <tr>
                    <td className='w-750'><span className='eleHeader'>4. Is client or LAR declining medication recommendation? </span>
                    <span className='small'>(Circle One)</span></td>
                 </tr>
                 <tr>
                    <td className='w-250'> <input type="radio" id="rbMedicationRecommendation_yes" name="rbMedicationRecommendation" className='add-only' value="Yes" /> Yes</td>
                    <td className='w-250'><input type="radio" id="rbMedicationRecommendation_No" name="rbMedicationRecommendation" className='add-only' value="No" /> No</td>
                 </tr>
              </table>
              <p className='w-750'>
                <span className='eleHeader'>5. What medications is the client currently taking? </span>
                <textarea id="txtCurrentlyMedications" name="txtCurrentlyMedications" className='add-only'></textarea>
              </p>
              <h3>Goal:</h3>
              <table>
                <tr>
                    <td className='w-750'><span className='eleHeader'>1. Progress?</span>
                    <span className='small'>(Circle One)</span></td>
                </tr>
                <tr>
                    <td className='w-250'><input type="radio" id="rbGoalProgress_1_1" name="rbGoalProgress_1_1" className='add-only' value="Minor" /> Minor</td>
                    <td className='w-250'><input type="radio" id="rbGoalProgress_1_2" name="rbGoalProgress_1_1" className='add-only' value="Moderate" /> Moderate</td>
                    <td className='w-250'><input type="radio" id="rbGoalProgress_1_3" name="rbGoalProgress_1_1" className='add-only' value="Significant" /> Significant</td>
                </tr>
              </table>
              <p className='w-750'>
                <span className='eleHeader'>2. What objectives/interventions are working and not working?</span>
                <textarea id="rbGoalobjectivesInterventions_1" name="rbGoalobjectivesInterventions_1" className='add-only'></textarea>
              </p>
              <p className='w-750'>
                <span className='eleHeader'>3. Suggestions for addition or deletion of goals/objectives/interventions?</span>
                <textarea id="rbSuggestionsFor_1" name="rbSuggestionsFor_1" className='add-only'></textarea>
              </p>
              <h3>Goal:</h3>
              <table>
                <tr>
                    <td className='w-750'><span className='eleHeader'>1. Progress?</span>
                    <span className='small'>(Circle One)</span></td>
                </tr>
                <tr>
                    <td className='w-250'><input type="radio" id="rbGoalProgress_2_1" name="rbGoalProgress_2_1" className='add-only' value="Minor" /> Minor</td>
                    <td className='w-250'><input type="radio" id="rbGoalProgress_2_2" name="rbGoalProgress_2_1" className='add-only' value="Moderate" /> Moderate</td>
                    <td className='w-250'><input type="radio" id="rbGoalProgress_2_3" name="rbGoalProgress_2_1" className='add-only' value="Significant" /> Significant</td>
                </tr>
              </table>
              <p className='w-750'>
                <span className='eleHeader'>2. What objectives/interventions are working and not working?</span>
                <textarea id="rbGoalobjectivesInterventions_2" name="rbGoalobjectivesInterventions_2" className='add-only'></textarea>
              </p>
              <p className='w-750'>
                <span className='eleHeader'>3. Suggestions for addition or deletion of goals/objectives/interventions?</span>
                <textarea id="rbSuggestionsFor_2" name="rbSuggestionsFor_2" className='add-only'></textarea>
              </p>
              <h3>Goal:</h3>
              <table>
                <tr>
                    <td className='w-750'><span className='eleHeader'>1. Progress?</span>
                    <span className='small'>(Circle One)</span></td>
                </tr>
                <tr>
                    <td className='w-250'><input type="radio" id="rbGoalProgress_3_1" name="rbGoalProgress_3_1" className='add-only' value="Minor" /> Minor</td>
                    <td className='w-250'><input type="radio" id="rbGoalProgress_3_2" name="rbGoalProgress_3_1" className='add-only' value="Moderate" /> Moderate</td>
                    <td className='w-250'><input type="radio" id="rbGoalProgress_3_3" name="rbGoalProgress_3_1" className='add-only' value="Significant" /> Significant</td>
                </tr>
              </table>
              <p className='w-750'>
                <span className='eleHeader'>2. What objectives/interventions are working and not working?</span>
                <textarea id="rbGoalobjectivesInterventions_3" name="rbGoalobjectivesInterventions_3" className='add-only'></textarea>
              </p>
              <p className='w-750'>
                <span className='eleHeader'>3. Suggestions for addition or deletion of goals/objectives/interventions?</span>
                <textarea id="rbSuggestionsFor_3" name="rbSuggestionsFor_3" className='add-only'></textarea>
              </p>
            </div>
        </form>
    )
}







